/**
 * AssetRadar SPA entry point.
 *
 * The stylesheet is imported exactly once, here: `styles/global.css` carries the
 * design tokens every component class depends on, so it must be in the bundle
 * before any component renders (Vite hoists CSS imports into a single file).
 *
 * StrictMode is on deliberately. It double-invokes effects in development, which
 * is what surfaced the need for the `requestSeq` guard in `lib/auth.tsx` — a
 * second `GET /api/auth/me` must not be able to overwrite a newer result.
 */

import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { activateLocale, initialLocale } from './lib/locale';
import './styles/global.css';

const container = document.getElementById('root');
if (container === null) {
  // index.html always ships <div id="root">; a missing node means the HTML shell
  // was replaced (or the backend served the "Frontend not built" page), and a
  // hard error is far easier to diagnose than a silently blank screen.
  throw new Error('Mount point #root not found: index.html is not the AssetRadar shell.');
}

// The catalog is loaded BEFORE the first render: rendering earlier would show
// the German source texts for a moment and then flip to English.
await activateLocale(initialLocale());

createRoot(container).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
  </StrictMode>,
);
